import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from '../../../shared/_services/theme.service';
import { ChangeLanguageComponent } from '../change-language/change-language.component';
import { StepsProgressBarComponent } from '../steps-progress-bar/steps-progress-bar.component';

@Component({
	selector: 'app-steps-header',
	standalone: true,
	imports: [ChangeLanguageComponent, StepsProgressBarComponent],
	templateUrl: './steps-header.component.html',
	styles: ``,
})
export class StepsHeaderComponent {
	readonly tenantId: number;

	constructor(
		readonly themeService: ThemeService,
		private readonly router: Router,
	) {
		this.tenantId = themeService.getTenantId();
	}

	tornaAllaHome(): void {
		this.router.navigateByUrl(this.themeService.getLandingUrl());
	}
}
